import type { ApiProviderProfile } from '../types/matchmaking.types';

/**
 * Parse specialties from fetched profile or provider profile
 */
export const parseSpecialties = (
  fetchedProfile?: any,
  providerProfile?: ApiProviderProfile,
): string[] => {
  const raw = fetchedProfile?.specialties ?? providerProfile?.specialties ?? null;
  if (!raw) return [];
  if (Array.isArray(raw)) {
    return raw
      .map((item: any) => {
        if (typeof item === "string") {
          return item.trim();
        }
        if (item && typeof item === "object" && item.name) {
          return item.name.trim();
        }
        return null;
      })
      .filter((item: string | null): item is string => item !== null && item.length > 0);
  }
  if (typeof raw === "string") {
    return raw
      .split(/\r?\n|,/)
      .map((item: string) => item.trim())
      .filter((item: string) => item.length > 0);
  }
  return [];
};

/**
 * Parse expertise from fetched profile or provider profile
 */
export const parseExpertise = (
  fetchedProfile?: any,
  providerProfile?: ApiProviderProfile,
): string[] => {
  const raw = fetchedProfile?.expertise ?? providerProfile?.expertise_areas ?? null;
  if (!raw) return [];
  if (Array.isArray(raw)) {
    return raw
      .map((item: any) => {
        if (typeof item === "string") {
          return item.trim();
        }
        if (item && typeof item === "object" && item.name) {
          return item.name.trim();
        }
        return null;
      })
      .filter((item: string | null): item is string => item !== null && item.length > 0);
  }
  if (typeof raw === "string") {
    return raw
      .split(/\r?\n|,/)
      .map((item: string) => item.trim())
      .filter((item: string) => item.length > 0);
  }
  return [];
};

